module.exports = __webpack_public_path__ + "img/nav-right-with-contact-cjdr.05c97f28.png";